import React from "react";

export default function MSAccess_Exp() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MSAccess_Exp</h1>
      <p>This is the MSAccess_Exp component generated from the SQL JSON.</p>
    </div>
  );
}
